import { faWaveformLines } from '@fortawesome/pro-regular-svg-icons'

import { ItemDescription } from '..'

import Builder from './Builder'
import Element from './Element'
import Header from './Header'

export const itemDescription: ItemDescription<never, never> = {
  hasCustomFields: false,
  type: 'voiceTip',
  icon: faWaveformLines,
  label: 'Audio',
  Element,
  Builder,
  Header,
}
